<div class="share-my-bet__onboarding-message">{{ sitecore.shareMyBet.messages.OnboardingText }}</div>
<div class="share-my-bet__onboarding-close theme-ex" (click)="hideOnboarding($event)"></div>
